export default "__VITE_ASSET__BBKHgcpS__"